'use client'

import { PropsWithChildren } from 'react'

import { useAirbridgeContext } from '@/shared/config'

type Props = {
  className?: string
}

export const DeepLink = ({ children, className }: PropsWithChildren<Props>) => {
  const airbridge = useAirbridgeContext()

  const handleClick = () => {
    airbridge.openDeeplink({
      type: 'click',
      ctaParams: {
        cta_param_1: 'main',
        cta_param_2: 'banner_app_open',
        cta_param_3: '',
      },
    })
  }

  return (
    <div role="button" onClick={handleClick} className={className}>
      {children}
    </div>
  )
}
